import { Directive, ElementRef, EventEmitter, HostListener, Output, inject } from '@angular/core';

@Directive({
  selector: '[egClickOutside]',
  standalone: false,
})
export class ClickOutsideDirective {
  private elementRef = inject(ElementRef);

  @Output()
  outsideClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  @HostListener('document:mousedown', ['$event'])
  onClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.outsideClick.emit(event);
    }
  }
}
